<template>
  <div class="animated fadeIn">
    <Forms ref="frmGroup"
      :title="'CADASTRO DE TIPO DE DESPESAS - FOLLOWUP'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-12">
          <label ><small v-show="form.nome.required" class="text-danger">*</small> Nome da Despesa:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o Nome da Despesa'"
                          v-model="form.nome.value"
                          :size="form.nome.maxlength"
                          :required="form.nome.required"
                          :state="form.nome.state"></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row pt-3">
        <div class="col-md-2">
          <label><small v-show="form.anexo.required" class="text-danger">*</small>Requer Anexo?</label>
          <div class="input-group">
            <b-form-checkbox v-model="form.anexo.value" :value="true" :unchecked-value="false">
              <span style="padding-top: 3px; display: block;">Sim</span>
            </b-form-checkbox>
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'

import ExpenseTypeModel from '@/shared/models/configurations/expensetypemodel.js'
import ExpenseTypeForms from './expenseType-form.js'
import ExpenseTypeRepository from '@/shared/http/repositories/configurations/expensetype.js'

export default {
  name: 'ExpenseTypeAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: ExpenseTypeModel,
      form: ExpenseTypeForms
    }
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () {
    },
    onCreate () {
      loading.push()
      ExpenseTypeRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      ExpenseTypeRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/expenseType/components/add/expenseTypeAdd.vue